<!-- <div class="skeleton-main-container"> -->
  <div class="skeleton-card" [class.skeletoncard-w-sm]="cardWidthContainer">
    <div class="skeleton-card-header" [class.imageHeight]="imageHeightconatiner"></div>
    <div class="skeleton-card-body">
      <div class="skeleton-card-title"></div>
      <div class="skeleton-card-text"></div>
      <div class="skeleton-card-footer"></div>
    </div>
  </div>
<!-- </div> -->